import React, {
    ReactElement,
} from "react";
import { Dropdown as BootstrapDropdown, DropdownProps as BootstrapDropdownProps } from "react-bootstrap";

import Header from "./Header";
import Item from "./Item";
import Toggle from "./Toggle";
import Menu from "./Menu";
import Divider from "./Divider";
import Link from "./Link";
import ToggleIcon from "./ToggleIcon";

export type DropdownProps = BootstrapDropdownProps

const DropdownElement = React.forwardRef((
    args: DropdownProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactElement => {
    const {
        children,
        ...rest
    } = args;

    return (
        <BootstrapDropdown data-bs-display="static" ref={ref} {...rest}>
            {children}
        </BootstrapDropdown>
    );
});

DropdownElement.defaultProps = {
    className: "",
};

type DropdownType = typeof DropdownElement & {
    Header: typeof Header;
    Item: typeof Item;
    Toggle: typeof Toggle;
    Menu: typeof Menu;
    Divider: typeof Divider;
    Link: typeof Link;
    ToggleIcon: typeof ToggleIcon;
}

const Dropdown = DropdownElement as DropdownType;
Dropdown.Header = Header;
Dropdown.Item = Item;
Dropdown.Toggle = Toggle;
Dropdown.Menu = Menu;
Dropdown.Divider = Divider;
Dropdown.Link = Link;
Dropdown.ToggleIcon = ToggleIcon;

export default Dropdown;
